<template>
  <on-order
    :partId="partId"
    :crfqLineId="reqLineId"
    isAvailableParts
    isPOTab />
</template>

<script>
/*import { mapGetters } from 'vuex';*/

import { GRID_ID } from '@/shared/constants';
import OnOrder from '@/shared/components/OnOrder';

export default {
  props: {
    reqLineId: {
      type: [Number, String],
      default: 0
    },
    partId: {
      type: [Number, String],
      default: 0
    },
  },
  /*computed: {
    ...mapGetters('requirements', [
      'selectedRequirement',
    ]),
    ...mapGetters('requirementAdd', [
      'currentPart',
    ]),
  },*/
  data: () => ({
    gridId: GRID_ID.REQUIREMENT_ON_ORDER,
  }),
  components: {
    OnOrder,
  },
};
</script>
